if (!customElements.get('collection-view-toggle')) {
  class CollectionViewToggle extends HTMLElement {
    connectedCallback() {
      this.collection = this.closest('.collection');
      this.storageKey = this.dataset.storageKey || 'collection-view-cols';
      this.defaultColsDesktop = this.getAttribute('data-default-cols') || '5';
      this.defaultColsMobile = this.getAttribute('data-default-cols-mobile') || '2';
      this.mq = window.matchMedia('(max-width: 749px)');
      this.mobileCols = ['2', '4'];
      this.desktopCols = ['5', '7'];

      this.syncButtons();
      const saved = this.getSavedCols();
      this.cols = saved || this.getDefaultCols();
      this.apply();

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const nextCols = button.dataset.cols;
          if (!nextCols || nextCols === this.cols) return;

          this.cols = nextCols;
          this.saveCols();
          this.apply();
          document.dispatchEvent(new CustomEvent('collection-facets:updated', { bubbles: true }));
        });
      });

      this.onViewportChange = () => {
        this.syncButtons();
        if (!this.isColsAllowed(this.cols)) {
          this.cols = this.getDefaultCols();
          this.saveCols();
        }
        this.apply();
      };
      this.mq.addEventListener('change', this.onViewportChange);

      const gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer) {
        this.gridObserver = new MutationObserver(() => {
          this.apply();
        });
        this.gridObserver.observe(gridContainer, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.gridObserver?.disconnect();
      this.mq?.removeEventListener('change', this.onViewportChange);
    }

    syncButtons() {
      this.buttons = Array.from(this.querySelectorAll('[data-cols]'));
    }

    isMobile() {
      return this.mq.matches;
    }

    allowedCols() {
      return this.isMobile() ? this.mobileCols : this.desktopCols;
    }

    isColsAllowed(cols) {
      return this.allowedCols().includes(String(cols));
    }

    getDefaultCols() {
      return this.isMobile() ? this.defaultColsMobile : this.defaultColsDesktop;
    }

    getSavedCols() {
      if (window.Shopify && window.Shopify.designMode) return null;

      try {
        const saved = JSON.parse(localStorage.getItem(this.storageKey) || 'null');
        if (saved?.cols && this.isColsAllowed(saved.cols)) {
          return saved.cols;
        }
      } catch (e) {
        /* storage unavailable */
      }

      return null;
    }

    saveCols() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({ cols: this.cols }));
      } catch (e) {
        /* storage unavailable */
      }
    }

    apply() {
      this.setAttribute('data-cols', this.cols);

      this.buttons.forEach((button) => {
        const isActive = button.dataset.cols === this.cols;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (!this.collection) return;

      this.collection.setAttribute('data-view-cols', this.cols);
      this.collection.classList.toggle('collection--cols-7', this.cols === '7');
      this.collection.classList.toggle('collection--cols-4', this.cols === '4');

      const productGrid = document.getElementById('product-grid');
      if (productGrid) {
        productGrid.setAttribute('data-cols', this.cols);
      }

      const defaultCols = this.getDefaultCols();
      if (this.cols === defaultCols) {
        this.collection.style.removeProperty('--products_per_row');
      } else {
        this.collection.style.setProperty('--products_per_row', this.cols);
      }
    }
  }

  customElements.define('collection-view-toggle', CollectionViewToggle);
}
